// extracted by mini-css-extract-plugin
export var banner = "_g7-0";
export var closeButton = "_g7-2";
export var greenCheckmark = "_g7-3";
export var hereLink = "_g7-4";
export var titleIcon = "_g7-1";